import { css } from '@lyearn/style';

export const circularProgress = css`
  .CircularProgressbar .CircularProgressbar-path {
    stroke: var(--icon-info);
  }
`;
